import React from 'react';
import {useTranslation} from 'react-i18next';
import {components} from 'react-select';
import type {GroupBase, MenuListProps} from 'react-select';
import {SelectOption} from '@chekin/core';
import {MenuItemLoadingMessage} from './styled';
import type {SelectProps} from '../types';

const isArray = (children: React.ReactNode): children is [] => {
  return !!(children && typeof children === 'object' && 'length' in children);
};

const SelectMenuList = <T, V, L>(
  props: MenuListProps<SelectOption<T, V, L>, false, GroupBase<SelectOption<T, V, L>>> & {
    children: React.ReactNode;
  },
) => {
  const {t} = useTranslation();
  const selectProps = props.selectProps as unknown as SelectProps<T, V, L>;
  const {children} = props;
  const {trimFilterBy, isLoading} = selectProps;

  const getFilteredChildren = () => {
    if (isArray(children) && trimFilterBy) {
      return children?.slice(0, trimFilterBy);
    } else {
      return children;
    }
  };

  const filteredChildren = getFilteredChildren();

  if (isLoading) {
    return (
      <MenuItemLoadingMessage className="select__loading-message kiosko:text-kiosko-s">
        {t('loading')}...
      </MenuItemLoadingMessage>
    );
  }
  return (
    <components.MenuList
      {...props}
      className="kiosko:!w-full kiosko:!max-h-[400px]"
      children={filteredChildren}
    />
  );
};

export {SelectMenuList};
